export const BAR_GRAPH_DATA = {
  en: {
    noDataText: "No data available",
  },
  ar: {
    noDataText: "لا يوجد بيانات متاحة",
  },
};

export const MONEY_SPENT_PER_LANGUAGE_DATA = {
  en: {
    moneyTitle: "Money Spent per Language",
  },
  ar: {
    moneyTitle: "المال المنفق لكل لغة",
  },
};

export const DELETE_USER_MODAL_DATA = {
  en:{
    title: "End Session",
  },
  ar:{
    title: "إنهاء الجلسة",
  }
}
